import { FC } from 'react';

import { Box } from '@mui/material';

import { AccountDelete } from './AccountDelete';
import { AccountEmail } from './AccountEmail';
import { AccountPassword } from './AccountPassword';
import { AccountPersonalInfo } from './AccountPersonalInfo';
import { AccountTermsAndConditions } from './AccountTermsAndConditions';

import styles from './AccountSettings.module.scss';

export const UserAccountSettings: FC = () => {
  return (
    <Box className={styles.userAccountSettingsWrapper}>
      <AccountPersonalInfo />
      <AccountEmail />
      <AccountPassword />
      <AccountTermsAndConditions />
      <AccountDelete />
    </Box>
  );
};
